import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex flex-row gap-5" }
const _hoisted_3 = { class: "d-flex flex-row gap-5" }
const _hoisted_4 = { class: "d-flex justify-content-end" }
const _hoisted_5 = ["onClick", "data-kt-indicator"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoleSelect = _resolveComponent("RoleSelect")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "initial-values": _ctx.formData,
    "validation-schema": _ctx.formSchema,
    ref: "userForm"
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        id: "kt_modal_user_form",
        novalidate: "novalidate",
        onSubmit: _withModifiers(($event: any) => (handleSubmit(values, _ctx.handleSubmitForm)), ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RoleSelect, {
            containerClass: "w-50 pr-2 mb-7",
            label: "Select a Role",
            placeholder: "Select a Role",
            required: true,
            showLabel: true,
            options: _ctx.roles,
            value: _ctx.userRole,
            name: "roles",
            disabled: _ctx.updateMode ?? true,
            onChange: _ctx.handleRoleChange,
            onClose: _ctx.handleRoleClose
          }, null, 8, ["options", "value", "disabled", "onChange", "onClose"]),
          _createVNode(_component_FormField, {
            required: true,
            value: values.email,
            containerClass: "w-50 mb-7",
            formControlClass: "form-control",
            label: "Email",
            showLabel: true,
            name: "email",
            placeholder: "Email",
            type: "email"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FormField, {
            required: true,
            value: values.first_name,
            containerClass: "w-50 mb-7",
            formControlClass: "form-control",
            label: "First Name",
            showLabel: true,
            name: "first_name",
            placeholder: "First Name",
            type: "text"
          }, null, 8, ["value"]),
          _createVNode(_component_FormField, {
            required: true,
            value: values.last_name,
            containerClass: "w-50 mb-7",
            formControlClass: "form-control",
            label: "Last Name",
            showLabel: true,
            name: "last_name",
            placeholder: "Last Name",
            type: "text"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
            type: "reset",
            id: "kt_modal_new_card_cancel",
            class: "btn btn-new-design-secondary me-3"
          }, " Cancel "),
          _createElementVNode("button", {
            onClick: validate,
            id: "kt_modal_new_card_submit",
            class: "btn btn-new-design-primary",
            "data-kt-indicator": _ctx.loading ? 'on' : null
          }, _hoisted_8, 8, _hoisted_5)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["initial-values", "validation-schema"]))
}